(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[51246,19341,97],{

/***/ 88668:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(83369),
    setCacheAdd = __webpack_require__(90619),
    setCacheHas = __webpack_require__(72385);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),

/***/ 47443:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(42118);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),

/***/ 1196:
/***/ (function(module) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),

/***/ 41848:
/***/ (function(module) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),

/***/ 42118:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(41848),
    baseIsNaN = __webpack_require__(62722),
    strictIndexOf = __webpack_require__(42351);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),

/***/ 62722:
/***/ (function(module) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),

/***/ 45652:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var SetCache = __webpack_require__(88668),
    arrayIncludes = __webpack_require__(47443),
    arrayIncludesWith = __webpack_require__(1196),
    cacheHas = __webpack_require__(74757),
    createSet = __webpack_require__(23593),
    setToArray = __webpack_require__(21814);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),

/***/ 74757:
/***/ (function(module) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),

/***/ 23593:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Set = __webpack_require__(58525),
    noop = __webpack_require__(50308),
    setToArray = __webpack_require__(21814);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),

/***/ 90619:
/***/ (function(module) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),

/***/ 72385:
/***/ (function(module) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),

/***/ 21814:
/***/ (function(module) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),

/***/ 42351:
/***/ (function(module) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),

/***/ 50308:
/***/ (function(module) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),

/***/ 87185:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseUniq = __webpack_require__(45652);

/**
 * This method is like `_.uniq` except that it accepts `comparator` which
 * is invoked to compare elements of `array`. The order of result values is
 * determined by the order they occur in the array.The comparator is invoked
 * with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.uniqWith(objects, _.isEqual);
 * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
 */
function uniqWith(array, comparator) {
  comparator = typeof comparator == 'function' ? comparator : undefined;
  return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
}

module.exports = uniqWith;


/***/ }),

/***/ 51246:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10253);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(18422);
/* harmony import */ var redux_apis_dataSending__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(56962);
/* harmony import */ var hooks_usePageClusters__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70080);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73331);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_7__);










var Typography = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 68837).then(__webpack_require__.bind(__webpack_require__, 59654));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(59654)
            ];
        }
    }
});
var Button = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 49105).then(__webpack_require__.bind(__webpack_require__, 49105));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(49105)
            ];
        }
    }
});
var SubscribeInCTAForm = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(84602), __webpack_require__.e(66244)]).then(__webpack_require__.bind(__webpack_require__, 66244));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(66244)
            ];
        }
    }
});
/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__(param) {
    var titles = param.titles, subtitle = param.subtitle, buttonTitle = param.buttonTitle, handleOnClick = param.handleOnClick, slug = param.slug;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,redux_apis_dataSending__WEBPACK_IMPORTED_MODULE_5__/* .useSubscribeMutation */ .iD)({
        fixedCacheKey: redux_apis_dataSending__WEBPACK_IMPORTED_MODULE_5__/* .SUBSCRIPTION_CASH_KEY */ .X3
    }), 2), subscribe = ref[0], ref1 = ref[1], tmp = ref1.data, subscriptionEmail = (tmp === void 0 ? {} : tmp).subscriptionEmail;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isSubscribeFormShown = ref2[0], setSubscribeFormShown = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isSubsribedInBlock = ref3[0], setSubsribedInBlock = ref3[1];
    var pageClusters = (0,hooks_usePageClusters__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)();
    var subscribeButtonClick = function() {
        if (handleOnClick) {
            return handleOnClick();
        }
        if (!subscriptionEmail) {
            return setSubscribeFormShown(true);
        }
        Promise.resolve(subscribe({
            email: subscriptionEmail,
            pageClusters: pageClusters
        }));
        setSubsribedInBlock(true);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().content), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().isSubscribed), isSubsribedInBlock)),
                children: [
                    !isSubsribedInBlock && (titles === null || titles === void 0 ? void 0 : titles.map(function(titleText, index) {
                        return titleText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Typography, {
                            variant: UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_9__/* .TYPOGRAPHY_TAGS.h3 */ .w1.h3,
                            size: UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_9__/* .TYPOGRAPHY_SIZE.headline24 */ .y3.headline24,
                            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().h3), (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().title)),
                            children: titleText
                        }, "titleText/".concat(index));
                    })),
                    !isSubsribedInBlock && subtitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Typography, {
                        variant: UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_9__/* .TYPOGRAPHY_TAGS.p */ .w1.p,
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().p), (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().subtitle)),
                        children: subtitle
                    }),
                    isSubsribedInBlock && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Typography, {
                        variant: UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_9__/* .TYPOGRAPHY_TAGS.h3 */ .w1.h3,
                        size: UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_9__/* .TYPOGRAPHY_SIZE.headline24 */ .y3.headline24,
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().h3), (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().title)),
                        children: "Thanks for your attention!"
                    }),
                    isSubsribedInBlock && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Typography, {
                        variant: UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_9__/* .TYPOGRAPHY_TAGS.p */ .w1.p,
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().p), (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().subtitle)),
                        children: "Check Inbox to confirm your subscription"
                    })
                ]
            }),
            !isSubscribeFormShown && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Button, {
                onClick: subscribeButtonClick,
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().button),
                "data-button": true,
                children: buttonTitle
            }),
            !isSubsribedInBlock && isSubscribeFormShown && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SubscribeInCTAForm, {
                slug: slug,
                onSubscriptionFinished: function() {
                    return setSubsribedInBlock(true);
                }
            })
        ]
    });
};


/***/ }),

/***/ 18422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "tj": function() { return /* binding */ useTypography; },
/* harmony export */   "w1": function() { return /* binding */ TYPOGRAPHY_TAGS; },
/* harmony export */   "y3": function() { return /* binding */ TYPOGRAPHY_SIZE; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2664);
/* harmony import */ var redux_selectors_layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19341);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34461);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_4__);







var TYPOGRAPHY_TAGS = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    p: "p",
    span: "span"
};
var TYPOGRAPHY_SIZE = {
    caption12: "caption",
    paragrapgh14: "paragrapgh-s",
    paragrapgh16: "paragrapgh-m",
    headline20: "headline-xs",
    headline24: "headline-s",
    headline38: "headline-m",
    headline46: "headline-l",
    headline56: "headline-xl"
};
var useTypography = function(_param) {
    var variant = _param.variant, isBold = _param.isBold, className = _param.className, children = _param.children, size = _param.size, mobileSize = _param.mobileSize, onClick = _param.onClick, tabIndex = _param.tabIndex, role = _param.role, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "variant",
        "isBold",
        "className",
        "children",
        "size",
        "mobileSize",
        "onClick",
        "tabIndex",
        "role"
    ]);
    var isDesktopResolution = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__.useSelector)(redux_selectors_layout__WEBPACK_IMPORTED_MODULE_3__/* .selectIsDesktop */ .Y6);
    var Tag = TYPOGRAPHY_TAGS[variant] || variant;
    var actualSize = isDesktopResolution || !mobileSize ? size : mobileSize;
    var classes = classnames__WEBPACK_IMPORTED_MODULE_0___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().typography), className, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default())[actualSize], (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().boldText), isBold));
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        Tag: Tag,
        children: children,
        classes: classes,
        onClick: onClick,
        tabIndex: tabIndex,
        role: role
    }, rest);
};


/***/ }),

/***/ 70080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ usePageClusters; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29815);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var redux_apis_blog__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9584);
/* harmony import */ var redux_apis_page__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85144);
/* harmony import */ var utils_appContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16515);
/* harmony import */ var utils_helper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6572);






function usePageClusters() {
    var pageFetchQuery = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(utils_appContext__WEBPACK_IMPORTED_MODULE_1__/* .PageFetchContext */ .E).pageFetchQuery;
    var ref = (0,redux_apis_blog__WEBPACK_IMPORTED_MODULE_2__/* .useGetArticleQuery */ .nB)(pageFetchQuery), tmp = ref.data, article = (tmp === void 0 ? {} : tmp).article;
    var ref1 = (0,utils_helper__WEBPACK_IMPORTED_MODULE_3__/* .getDocumentFields */ .OA)(article, [
        "clusters"
    ]), articleClusters = ref1.clusters;
    var ref2 = (0,redux_apis_page__WEBPACK_IMPORTED_MODULE_4__/* .useFetchPageQuery */ .oO)(pageFetchQuery), tmp1 = ref2.data, pageData = tmp1 === void 0 ? {} : tmp1;
    var pageClusters = pageData.clusters;
    return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(articleClusters || []).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(pageClusters || []));
}


/***/ }),

/***/ 9584:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$D": function() { return /* binding */ useGetArticlesRelatedToPersonQuery; },
/* harmony export */   "BZ": function() { return /* binding */ useGetBlogBundleQuery; },
/* harmony export */   "M9": function() { return /* binding */ useGetDraftArticleQuery; },
/* harmony export */   "i1": function() { return /* binding */ useGetSearchResultQuery; },
/* harmony export */   "nB": function() { return /* binding */ useGetArticleQuery; }
/* harmony export */ });
/* unused harmony exports useGetArticlesListQuery, useGetTagsQuery, useGetRelatedArticlesQuery */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(29815);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97582);
/* harmony import */ var lodash_uniqWith__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87185);
/* harmony import */ var lodash_uniqWith__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_uniqWith__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var utils_contentful_graphqlQuery__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24376);
/* harmony import */ var utils_contentful_helper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91217);
/* harmony import */ var utils_contentful_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65686);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96076);
/* harmony import */ var utils_error__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(93250);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91555);












var blogApi = ___WEBPACK_IMPORTED_MODULE_1__["default"].injectEndpoints({
    endpoints: function(builder) {
        return {
            getBlogBundle: builder.query({
                extraOptions: {
                    client: utils_contentful_client__WEBPACK_IMPORTED_MODULE_2__.blogClient,
                    type: ___WEBPACK_IMPORTED_MODULE_1__.BASEQUERY_TYPES.graphql
                },
                query: function query(param) {
                    var pageSlug = param.pageSlug, limit = param.limit, skip = param.skip, _order = param.order, order = _order === void 0 ? "[publishedAt_DESC]" : _order, _isTag = param.isTag, isTag = _isTag === void 0 ? false : _isTag, slug = param.slug;
                    return utils_contentful_graphqlQuery__WEBPACK_IMPORTED_MODULE_3__/* .GRAPHQL_QUERY.loadBlogBundle */ .f.loadBlogBundle({
                        pageSlug: pageSlug,
                        limit: limit,
                        skip: skip,
                        order: order,
                        isTag: isTag,
                        slug: slug
                    });
                },
                transformResponse: function transformResponse(response, _, param) {
                    var isTag = param.isTag;
                    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14;
                    var tags = (response === null || response === void 0 ? void 0 : (ref = response.tags) === null || ref === void 0 ? void 0 : ref.items) || [];
                    var page = (response === null || response === void 0 ? void 0 : (ref1 = response.page) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.items) === null || ref2 === void 0 ? void 0 : ref2[0]) || {};
                    var articles = isTag ? (response === null || response === void 0 ? void 0 : (ref3 = response.articlesByTag) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.items) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[0]) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.linkedFrom) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.articleCollection) === null || ref7 === void 0 ? void 0 : ref7.items) || [] : (response === null || response === void 0 ? void 0 : (ref8 = response.articles) === null || ref8 === void 0 ? void 0 : ref8.items) || [];
                    var total = isTag ? (response === null || response === void 0 ? void 0 : (ref9 = response.articlesByTag) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.items) === null || ref10 === void 0 ? void 0 : (ref11 = ref10[0]) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.linkedFrom) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.articleCollection) === null || ref13 === void 0 ? void 0 : ref13.total) || 0 : (response === null || response === void 0 ? void 0 : (ref14 = response.articles) === null || ref14 === void 0 ? void 0 : ref14.total) || 0;
                    return {
                        tags: tags,
                        page: page,
                        articles: articles,
                        total: total
                    };
                }
            }),
            getArticlesList: builder.query({
                extraOptions: {
                    client: utils_contentful_client__WEBPACK_IMPORTED_MODULE_2__.blogClient,
                    type: ___WEBPACK_IMPORTED_MODULE_1__.BASEQUERY_TYPES.graphql
                },
                query: function query(param) {
                    var slug = param.slug, skip = param.skip, limit = param.limit, _isTag = param.isTag, isTag = _isTag === void 0 ? false : _isTag, _order = param.order, order = _order === void 0 ? "[publishedAt_DESC]" : _order;
                    return isTag ? utils_contentful_graphqlQuery__WEBPACK_IMPORTED_MODULE_3__/* .GRAPHQL_QUERY.loadPreviewArticlesByTags */ .f.loadPreviewArticlesByTags({
                        limit: limit,
                        skip: skip,
                        order: order,
                        where: {
                            slug: slug
                        }
                    }) : utils_contentful_graphqlQuery__WEBPACK_IMPORTED_MODULE_3__/* .GRAPHQL_QUERY.loadPreviewArticles */ .f.loadPreviewArticles({
                        skip: skip,
                        limit: limit,
                        order: order
                    });
                },
                transformResponse: function transformResponse(response, _, param) {
                    var isTag = param.isTag;
                    return {
                        items: isTag ? (0,utils_contentful_helper__WEBPACK_IMPORTED_MODULE_4__/* .getGraphqlResultArticlesByTags */ .nd)(response) : (0,utils_contentful_helper__WEBPACK_IMPORTED_MODULE_4__/* .getGraphqlResultArticles */ .fH)(response),
                        total: isTag ? (0,utils_contentful_helper__WEBPACK_IMPORTED_MODULE_4__/* .getGraphqlResultTotalArticlesCountByTags */ .g3)(response) : (0,utils_contentful_helper__WEBPACK_IMPORTED_MODULE_4__/* .getGraphqlResultTotalArticlesCount */ .QX)(response)
                    };
                }
            }),
            getArticlesRelatedToPerson: builder.query({
                extraOptions: {
                    client: utils_contentful_client__WEBPACK_IMPORTED_MODULE_2__.blogClient,
                    type: ___WEBPACK_IMPORTED_MODULE_1__.BASEQUERY_TYPES.getEntries
                },
                query: function query(param) {
                    var id = param.id, skip = param.skip, limit = param.limit;
                    return {
                        contentType: "article",
                        additionalQueryParams: {
                            links_to_entry: id,
                            order: "-fields.publishedAt",
                            skip: skip,
                            limit: limit
                        }
                    };
                },
                transformResponse: function transformResponse(response) {
                    return {
                        items: response.items,
                        total: response.total
                    };
                }
            }),
            getTags: builder.query({
                extraOptions: {
                    client: utils_contentful_client__WEBPACK_IMPORTED_MODULE_2__.blogClient,
                    type: ___WEBPACK_IMPORTED_MODULE_1__.BASEQUERY_TYPES.graphql
                },
                query: function query() {
                    return utils_contentful_graphqlQuery__WEBPACK_IMPORTED_MODULE_3__/* .GRAPHQL_QUERY.loadTag */ .f.loadTag({});
                },
                transformResponse: function transformResponse(response) {
                    return (0,utils_contentful_helper__WEBPACK_IMPORTED_MODULE_4__/* .getGraphqlResultTags */ .u6)(response);
                }
            }),
            getArticle: builder.query({
                extraOptions: {
                    client: utils_contentful_client__WEBPACK_IMPORTED_MODULE_2__.blogClient,
                    type: ___WEBPACK_IMPORTED_MODULE_1__.BASEQUERY_TYPES.getEntries
                },
                queryFn: function queryFn(param, _, __, baseQuery) {
                    var slug = param.slug;
                    return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                        var ref, ref1, ref2, article, e;
                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _state.trys.push([
                                        0,
                                        2,
                                        ,
                                        3
                                    ]);
                                    if (!slug) {
                                        return [
                                            2,
                                            {
                                                error: "Wrong argument"
                                            }
                                        ];
                                    }
                                    return [
                                        4,
                                        baseQuery({
                                            contentType: "article",
                                            query: {
                                                slug: slug
                                            }
                                        })
                                    ];
                                case 1:
                                    article = (ref = _state.sent()) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.items) === null || ref2 === void 0 ? void 0 : ref2[0];
                                    // const {
                                    //   publishedAt,
                                    //   tagsList,
                                    // } = getDocumentFields(article, ['tagsList', 'publishedAt']);
                                    // const [nextPrev, related] = await Promise.all([
                                    //   // blogClient.graphql(GRAPHQL_QUERY.getNearbyArticle({
                                    //   //   limit: 2,
                                    //   //   // order: '[publishedAt_DESC]',
                                    //   //   where: { publishedAt_lt: publishedAt },
                                    //   // })),
                                    //   // blogClient.graphql(GRAPHQL_QUERY.getNearbyArticle({
                                    //   //   limit: 1,
                                    //   //   order: '[publishedAt_DESC]',
                                    //   //   where: { publishedAt_gt: publishedAt },
                                    //   // })),
                                    //   blogClient.graphql(GRAPHQL_QUERY.getRelatedArticles({
                                    //     limit: 10,
                                    //     where: { slug: tagsList[0].fields.slug },
                                    //   })),
                                    // ]);
                                    return [
                                        2,
                                        {
                                            data: {
                                                article: article
                                            }
                                        }
                                    ];
                                case 2:
                                    e = _state.sent();
                                    console.log(e, "-------------");
                                    return [
                                        3,
                                        3
                                    ];
                                case 3:
                                    return [
                                        2
                                    ];
                            }
                        });
                    })();
                },
                keepUnusedDataFor: 120
            }),
            getDraftArticle: builder.query({
                extraOptions: {
                    client: utils_contentful_client__WEBPACK_IMPORTED_MODULE_2__.blogPreviewClient,
                    type: ___WEBPACK_IMPORTED_MODULE_1__.BASEQUERY_TYPES.getEntries
                },
                query: function query(slug) {
                    return {
                        contentType: "article",
                        query: {
                            slug: slug
                        }
                    };
                },
                transformResponse: function transformResponse(response) {
                    return response.items[0];
                }
            }),
            getSearchResult: builder.query({
                extraOptions: {
                    client: utils_contentful_client__WEBPACK_IMPORTED_MODULE_2__.blogClient,
                    type: ___WEBPACK_IMPORTED_MODULE_1__.BASEQUERY_TYPES.graphql
                },
                queryFn: function queryFn(value, _, __, baseQuery) {
                    return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                        var ref, byTagRaw, byText, result, e;
                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (!value) {
                                        return [
                                            2,
                                            {
                                                data: []
                                            }
                                        ];
                                    }
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        3,
                                        ,
                                        4
                                    ]);
                                    return [
                                        4,
                                        Promise.all([
                                            baseQuery(utils_contentful_graphqlQuery__WEBPACK_IMPORTED_MODULE_3__/* .GRAPHQL_QUERY.loadPreviewArticlesByTags */ .f.loadPreviewArticlesByTags({
                                                where: {
                                                    title_contains: value
                                                },
                                                limit: utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .SEARCH_ARTICLES_LIMIT */ .WV
                                            })),
                                            baseQuery(utils_contentful_graphqlQuery__WEBPACK_IMPORTED_MODULE_3__/* .GRAPHQL_QUERY.loadPreviewArticles */ .f.loadPreviewArticles({
                                                order: "[publishedAt_DESC]",
                                                limit: utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .SEARCH_ARTICLES_LIMIT */ .WV,
                                                where: {
                                                    OR: [
                                                        {
                                                            title_contains: value
                                                        },
                                                        {
                                                            oldBody_contains: value
                                                        },
                                                        {
                                                            title_contains: value
                                                        }
                                                    ]
                                                }
                                            }))
                                        ])
                                    ];
                                case 2:
                                    ref = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"].apply */ .Z.apply(void 0, [
                                        _state.sent(),
                                        2
                                    ]), byTagRaw = ref[0], byText = ref[1];
                                    result = lodash_uniqWith__WEBPACK_IMPORTED_MODULE_0___default()((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,utils_contentful_helper__WEBPACK_IMPORTED_MODULE_4__/* .getGraphqlResultArticlesByTags */ .nd)(byTagRaw.data)).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,utils_contentful_helper__WEBPACK_IMPORTED_MODULE_4__/* .getGraphqlResultArticles */ .fH)(byText.data))), function(article1, article2) {
                                        return article1.slug === article2.slug;
                                    }).sort(function(a, b) {
                                        return Date.parse(a) - Date.parse(b);
                                    });
                                    return [
                                        2,
                                        {
                                            data: result
                                        }
                                    ];
                                case 3:
                                    e = _state.sent();
                                    (0,utils_error__WEBPACK_IMPORTED_MODULE_10__/* .handleError */ .S3)(e);
                                    return [
                                        2,
                                        {
                                            error: e.message
                                        }
                                    ];
                                case 4:
                                    return [
                                        2
                                    ];
                            }
                        });
                    })();
                }
            })
        };
    }
});
var useGetBlogBundleQuery = blogApi.useGetBlogBundleQuery, useGetArticlesListQuery = blogApi.useGetArticlesListQuery, useGetTagsQuery = blogApi.useGetTagsQuery, useGetArticleQuery = blogApi.useGetArticleQuery, useGetSearchResultQuery = blogApi.useGetSearchResultQuery, useGetDraftArticleQuery = blogApi.useGetDraftArticleQuery, useGetRelatedArticlesQuery = blogApi.useGetRelatedArticlesQuery, useGetArticlesRelatedToPersonQuery = blogApi.useGetArticlesRelatedToPersonQuery;
/* harmony default export */ __webpack_exports__["ZP"] = (blogApi);


/***/ }),

/***/ 85144:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "oO": function() { return /* binding */ useFetchPageQuery; }
/* harmony export */ });
/* unused harmony exports useGetPageSearchResultQuery, useGetPageSearchResultFallbackQuery */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(29815);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97582);
/* harmony import */ var utils_helper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6572);
/* harmony import */ var utils_contentful_graphqlQuery__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(24376);
/* harmony import */ var utils_contentful_client__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(65686);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96076);
/* harmony import */ var utils_contentful_helper__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(91217);
/* harmony import */ var utils_error__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(93250);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91555);












var pageApi = ___WEBPACK_IMPORTED_MODULE_0__["default"].injectEndpoints({
    endpoints: function(builder) {
        return {
            fetchPage: builder.query({
                queryFn: function queryFn(value) {
                    return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
                        var client, ref, ref1, response, data, e;
                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (!value) {
                                        return [
                                            2,
                                            {
                                                data: {}
                                            }
                                        ];
                                    }
                                    client = utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .PAGES_FALLBACK_CONTENTFUL.includes */ .Bt.includes(value) ? utils_contentful_client__WEBPACK_IMPORTED_MODULE_4__.fallbackClient : utils_contentful_client__WEBPACK_IMPORTED_MODULE_4__.contentfulClient;
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        3,
                                        ,
                                        4
                                    ]);
                                    return [
                                        4,
                                        client.getEntries({
                                            contentType: "page",
                                            additionalQueryParams: {
                                                "fields.slug": value
                                            }
                                        })
                                    ];
                                case 2:
                                    response = _state.sent();
                                    data = (response === null || response === void 0 ? void 0 : (ref = response.items) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.fields) || {};
                                    return [
                                        2,
                                        {
                                            data: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, data), {
                                                metaData: {
                                                    metaTitle: data.metaTitle || "",
                                                    metaDescription: data.metaDescription || "",
                                                    metaRobots: data.metaRobots || "",
                                                    ogImage: (0,utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .getFileUrl */ .qm)(data.ogImage)
                                                }
                                            })
                                        }
                                    ];
                                case 3:
                                    e = _state.sent();
                                    (0,utils_error__WEBPACK_IMPORTED_MODULE_8__/* .handleError */ .S3)(e);
                                    return [
                                        2,
                                        {
                                            error: e.message
                                        }
                                    ];
                                case 4:
                                    return [
                                        2
                                    ];
                            }
                        });
                    })();
                }
            }),
            getPageSearchResult: builder.query({
                extraOptions: {
                    type: ___WEBPACK_IMPORTED_MODULE_0__.BASEQUERY_TYPES.graphql
                },
                queryFn: function queryFn(value, _, __, baseQuery) {
                    return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
                        var byText, result, e;
                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (!value) {
                                        return [
                                            2,
                                            {
                                                data: []
                                            }
                                        ];
                                    }
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        3,
                                        ,
                                        4
                                    ]);
                                    return [
                                        4,
                                        baseQuery(utils_contentful_graphqlQuery__WEBPACK_IMPORTED_MODULE_9__/* .GRAPHQL_QUERY.loadPreviewPages */ .f.loadPreviewPages({
                                            limit: utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .SEARCH_ARTICLES_LIMIT */ .WV,
                                            where: {
                                                pageTitle_contains: value,
                                                slug_not_in: utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .PAGES_EXCLUDE_SEARCH */ .fb
                                            }
                                        }))
                                    ];
                                case 2:
                                    byText = _state.sent();
                                    result = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,utils_contentful_helper__WEBPACK_IMPORTED_MODULE_11__/* .getGraphqlResultPages */ .ke)(byText.data));
                                    return [
                                        2,
                                        {
                                            data: result
                                        }
                                    ];
                                case 3:
                                    e = _state.sent();
                                    (0,utils_error__WEBPACK_IMPORTED_MODULE_8__/* .handleError */ .S3)(e);
                                    return [
                                        2,
                                        {
                                            error: e.message
                                        }
                                    ];
                                case 4:
                                    return [
                                        2
                                    ];
                            }
                        });
                    })();
                }
            }),
            getPageSearchResultFallback: builder.query({
                extraOptions: {
                    type: ___WEBPACK_IMPORTED_MODULE_0__.BASEQUERY_TYPES.graphql,
                    client: utils_contentful_client__WEBPACK_IMPORTED_MODULE_4__.fallbackClient
                },
                queryFn: function queryFn(value, _, __, baseQuery) {
                    return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
                        var byText, result, e;
                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (!value) {
                                        return [
                                            2,
                                            {
                                                data: []
                                            }
                                        ];
                                    }
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        3,
                                        ,
                                        4
                                    ]);
                                    return [
                                        4,
                                        baseQuery(utils_contentful_graphqlQuery__WEBPACK_IMPORTED_MODULE_9__/* .GRAPHQL_QUERY.loadPreviewPages */ .f.loadPreviewPages({
                                            limit: utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .SEARCH_ARTICLES_LIMIT */ .WV,
                                            where: {
                                                pageTitle_contains: value,
                                                slug_not_in: utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .PAGES_EXCLUDE_SEARCH */ .fb
                                            }
                                        }))
                                    ];
                                case 2:
                                    byText = _state.sent();
                                    result = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,utils_contentful_helper__WEBPACK_IMPORTED_MODULE_11__/* .getGraphqlResultPages */ .ke)(byText.data));
                                    return [
                                        2,
                                        {
                                            data: result
                                        }
                                    ];
                                case 3:
                                    e = _state.sent();
                                    (0,utils_error__WEBPACK_IMPORTED_MODULE_8__/* .handleError */ .S3)(e);
                                    return [
                                        2,
                                        {
                                            error: e.message
                                        }
                                    ];
                                case 4:
                                    return [
                                        2
                                    ];
                            }
                        });
                    })();
                }
            })
        };
    }
});
var useFetchPageQuery = pageApi.useFetchPageQuery, useGetPageSearchResultQuery = pageApi.useGetPageSearchResultQuery, useGetPageSearchResultFallbackQuery = pageApi.useGetPageSearchResultFallbackQuery;
/* harmony default export */ __webpack_exports__["ZP"] = (pageApi);


/***/ }),

/***/ 19341:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bw": function() { return /* binding */ selectIsSmallTablet; },
/* harmony export */   "Tr": function() { return /* binding */ selectIsPageReadyToDisplay; },
/* harmony export */   "Y6": function() { return /* binding */ selectIsDesktop; },
/* harmony export */   "aT": function() { return /* binding */ selectIsTablet; },
/* harmony export */   "cF": function() { return /* binding */ selectIsFirstPageLoaded; },
/* harmony export */   "eD": function() { return /* binding */ selectIsMobile; },
/* harmony export */   "qL": function() { return /* binding */ selectIsMobileCategotiesOpened; }
/* harmony export */ });
var selectIsMobileCategotiesOpened = function(state) {
    return state.layout.isMobileCategotiesOpened;
};
var selectIsPageReadyToDisplay = function(state) {
    return state.layout.isPageReadyToDisplay;
};
var selectIsFirstPageLoaded = function(state) {
    return state.layout.isFirstPageLoaded;
};
var selectIsMobile = function(state) {
    return state.layout.isMobileResolution;
};
var selectIsTablet = function(state) {
    return state.layout.isTabletResolution;
};
var selectIsSmallTablet = function(state) {
    return state.layout.isSmallTabletResolution;
};
var selectIsDesktop = function(state) {
    return state.layout.isDesktopResolution;
};


/***/ }),

/***/ 34461:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"boldText":"styles_boldText__iI9uz","headline-xl":"styles_headline-xl__HRBMS","headline-l":"styles_headline-l__Veh_x","headline-m":"styles_headline-m__gfh2N","headline-s":"styles_headline-s___kodX","headline-xs":"styles_headline-xs__XhN56","paragrapgh-m":"styles_paragrapgh-m__QFKni","paragrapgh-s":"styles_paragrapgh-s__4Eq1X","caption":"styles_caption__y7HHJ"};

/***/ })

}]);